import { MigrationPage } from "../MigrationPage";

const WebTrafficOptimization = (): JSX.Element => (
  <MigrationPage title="Web Traffic Optimization" pageType="Web Traffic Optimization" />
);

export default WebTrafficOptimization;
